import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
  selector: 'registration-entry-editor-shell',
  templateUrl: './registration-entry-editor-shell.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: ControlContainer }],
})
export class RegistrationEntryEditorShellComponent {
  @Input()
  mode: 'add' | 'edit' = 'add';

  @Input()
  addTitle = '';

  @Input()
  editTitle = '';

  @Input()
  invalid = false;

  @Input()
  invalidHeader?: string;

  @Input()
  invalidBody?: string;

  @Input()
  cancelTooltip = '';

  @Output()
  cancel = new EventEmitter<void>();

  @Output()
  save = new EventEmitter<void>();
}
